"use strict";

export function initInScope ($scope) {
    let pendingRequest = null;

    $scope.find('.js-voucher-remove').on('click', function (e) {

        let $container = $(this),
            $ajaxUrl = $container.attr('data-voucher-route'),
            $redirect = $container.attr('data-voucher-redirect'),
            $voucherCode = $container.attr('data-voucher-code');

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }

        pendingRequest = $.ajax($ajaxUrl, {
            type: 'POST',
            dataType: 'json',
            data: { 'voucher': $voucherCode, 'redirect': $redirect},
        }).done(function () {
            console.log('done');
            window.location.href = $redirect;
            window.location.reload(true);
        }
        ).fail(
            console.log('voucher request failed')
        );

        console.log(pendingRequest);
        console.log($redirect);
    });
}